import type { ReactNode } from "react";
import * as React from "react";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { NavigationBlockerProvider } from "./NavigationBlocker";
export function OctopusRouter({ children }: {
    children: ReactNode;
}) {
    const router = React.useMemo(() => createHashRouter([
        {
            path: "*",
            element: <NavigationBlockerProvider>{children}</NavigationBlockerProvider>,
        },
    ]), [children]);
    return <RouterProvider router={router}/>;
}
